export enum ChargingMethodType {
    Default = "Default",
    FullCharge = "FullCharge",
    Amount = "Amount",
    Units = "Units",
    Time = "Time",
    SoC = "SoC",
}
